import _classCallCheck from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { isScaleChannel } from '../../channel';
import { vgField as fieldRef } from '../../channeldef';
import { isPathMark } from '../../mark';
import { hasContinuousDomain } from '../../scale';
import { keys } from '../../util';
import { DataFlowNode } from './dataflow';
export var FilterInvalidNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(FilterInvalidNode, _DataFlowNode);

  function FilterInvalidNode(parent, fieldDefs) {
    var _this;

    _classCallCheck(this, FilterInvalidNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FilterInvalidNode).call(this, parent));
    _this.fieldDefs = fieldDefs;
    return _this;
  }

  _createClass(FilterInvalidNode, [{
    key: "clone",
    value: function clone() {
      return new FilterInvalidNode(null, Object.assign({}, this.fieldDefs));
    }
  }, {
    key: "assemble",
    // create the VgTransforms for each of the filtered fields
    value: function assemble() {
      var _this2 = this;

      var filters = keys(this.filter).reduce(function (vegaFilters, field) {
        var fieldDef = _this2.fieldDefs[field];
        var ref = fieldRef(fieldDef, {
          expr: 'datum'
        });

        if (fieldDef !== null) {
          vegaFilters.push("".concat(ref, " !== null"));
          vegaFilters.push("!isNaN(".concat(ref, ")"));
        }

        return vegaFilters;
      }, []);
      return filters.length > 0 ? {
        type: 'filter',
        expr: filters.join(' && ')
      } : null;
    }
  }, {
    key: "filter",
    get: function get() {
      return this.fieldDefs;
    }
  }], [{
    key: "make",
    value: function make(parent, model) {
      var config = model.config,
          mark = model.mark;

      if (config.invalidValues !== 'filter') {
        return null;
      }

      var filter = model.reduceFieldDef(function (aggregator, fieldDef, channel) {
        var scaleComponent = isScaleChannel(channel) && model.getScaleComponent(channel);

        if (scaleComponent) {
          var scaleType = scaleComponent.get('type'); // While discrete domain scales can handle invalid values, continuous scales can't.
          // Thus, for non-path marks, we have to filter null for scales with continuous domains.
          // (For path marks, we will use "defined" property and skip these values instead.)

          if (hasContinuousDomain(scaleType) && !fieldDef.aggregate && !isPathMark(mark)) {
            aggregator[fieldDef.field] = fieldDef;
          }
        }

        return aggregator;
      }, {});

      if (!keys(filter).length) {
        return null;
      }

      return new FilterInvalidNode(parent, filter);
    }
  }]);

  return FilterInvalidNode;
}(DataFlowNode);